export function pickIdleDiagnostics(left, right) {
  if (!left) return right || null;
  if (!right) return left;
  const leftAt = Number(left.checkedAt) || 0;
  const rightAt = Number(right.checkedAt) || 0;
  return leftAt >= rightAt ? left : right;
}

export function getIdleDiagnosticsPresentation(idleDiagnostics) {
  if (!idleDiagnostics || !idleDiagnostics.status) {
    return {
      label: "Not checked",
      color: "default",
      tooltip: "Edge has not run idle RCON plugin diagnostics on this server yet.",
    };
  }

  if (idleDiagnostics.status === "checking") {
    return {
      label: "Checking",
      color: "default",
      tooltip: "Edge is running meta list / css_plugins list against this server.",
    };
  }

  if (idleDiagnostics.ok || idleDiagnostics.status === "passed") {
    return {
      label: "OK",
      color: "success",
      tooltip: "Idle RCON diagnostics passed. CounterStrikeSharp, MatchZy, and TB Anti-Cheat are loaded.",
    };
  }

  const issues = Array.isArray(idleDiagnostics.issues)
    ? idleDiagnostics.issues.filter(Boolean)
    : [];
  return {
    label: "Failed",
    color: "error",
    tooltip:
      issues.length > 0
        ? issues.join(" ")
        : "Idle RCON plugin diagnostics failed.",
  };
}

export function formatIdleDiagnosticsTime(checkedAt) {
  if (!checkedAt) return null;
  const date = new Date(checkedAt);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString();
}
